import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MessageService, LazyLoadEvent } from 'primeng/api';
import { TaskService } from '@app/_components/task/task.service';
import { getDomainOptions } from '@app/_constants/task-code-registry';

@Component({
  selector: 'app-task-template-list',
  templateUrl: './template-list.component.html',
  styleUrls: ['./template-list.component.scss'],
  providers: [MessageService],
  standalone: false
})
export class TaskTemplateListComponent implements OnInit {

  templates: any[] = [];
  loading = true;
  recordTotal = 0;
  first = 0;
  rows = 50;
  multiSortMeta = [];

  regionOptions = getDomainOptions('REGION');
  priorityOptions = getDomainOptions('PRIORITY');

  regionFilter: number | null = null;

  columns = [
    { field: 'name', header: 'Name' },
    { field: 'region', header: 'Region' },
    { field: 'priorityTier', header: 'Priority Tier' },
    { field: 'estimatedTotalCost', header: 'Est. Cost' },
    { field: 'isActive', header: 'Active' },
    { field: 'createDate', header: 'Created' }
  ];

  constructor(
    private taskService: TaskService,
    public router: Router,
    public messageService: MessageService
  ) {}

  ngOnInit(): void {
    this.loadTemplates();
  }

  loadTemplates(): void {
    this.loading = true;
    const filters: any = {
      isTemplate: { value: true, matchMode: 'equals' }
    };
    if (this.regionFilter != null) {
      filters.region = { value: this.regionFilter, matchMode: 'equals' };
    }

    this.taskService.findByFilter(
      this.first / this.rows,
      this.rows,
      'name',
      1,
      null,
      null,
      filters
    ).subscribe({
      next: (res) => {
        if (res && res.data) {
          this.templates = res.data.tasks || [];
          this.recordTotal = res.page ? (res.page.recordTotal ?? res.page.totalElements ?? this.templates.length) : this.templates.length;
        } else {
          this.templates = [];
        }
        this.loading = false;
      },
      error: () => {
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to load templates' });
        this.loading = false;
      }
    });
  }

  loadLazy(event: LazyLoadEvent): void {
    this.first = event.first || 0;
    this.rows = event.rows || 50;
    this.loadTemplates();
  }

  onNewTemplate(): void {
    this.router.navigate(['/task-templates', 'new']);
  }

  onCloneTemplate(template: any, event: Event): void {
    event.stopPropagation();
    this.router.navigate(['/task-templates', 'clone', template.taskId]);
  }

  onRowSelect(event: any): void {
    this.router.navigate(['/task-templates', event.data.taskId]);
  }

  getPriorityLabel(value: number): string {
    const opt = this.priorityOptions.find(o => o.value === value);
    return opt ? opt.label : (value != null ? String(value) : '');
  }

  getRegionLabel(value: number): string {
    const opt = this.regionOptions.find(o => o.value === value);
    return opt ? opt.label : (value != null ? String(value) : '');
  }

  applyFilters(): void {
    this.first = 0;
    this.loadTemplates();
  }
}
